import { io } from "socket.io-client";
import config from "../../../config";

/**
 * Shared socket connection.
 *
 * Hardened against transport drops during long server-driven jobs (bulk fee
 * calculation emits thousands of events over several minutes):
 *
 * - `transports: ["websocket", "polling"]` - try WebSocket first. The default
 *   order starts with HTTP long-polling and upgrades, which is what produced
 *   the repeated `transport=polling` handshakes seen when a run stalled.
 *   Polling is kept as a fallback for networks that block WebSockets.
 * - `timeout` - allow more time for the initial handshake on slow links.
 * - `reconnection*` - keep retrying indefinitely with capped backoff so a
 *   transient network blip doesn't leave the client permanently detached.
 */
const socket = io(config.api.url.replace("/v1", ""), {
  transports: ["websocket", "polling"],
  timeout: 20000,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

/**
 * Socket.io event names - mirrors backend `src/lib/v1/shared/events.ts`.
 */
export const SOCKET_EVENTS = {
  /** Bulk invoice generation started (before preload) */
  BULK_START: "bulk:start",
  /** One invoice created during bulk generation */
  INVOICE_PROCESSED: "bulk:invoice",
};

export { socket };
